import {TheBorderFreeSpinIdlePresentation} from "../freespin/TheBorderFreeSpinIdlePresentation";
import {TheBorderFreeSpinIntroRunner} from "../../presentationrunners/freespin/TheBorderFreeSpinIntroRunner";
import {TheBorderSuperFSIntroRunner} from "../../presentationrunners/superfreespin/TheBorderSuperFSIntroRunner";

/**
 * Created by Jerker Nord on 2022-06-30.
 */

export class TheBorderSuperFSIdlePresentation extends TheBorderFreeSpinIdlePresentation{

    constructor() {
        super();
        this._presentations = [
            new TheBorderSuperFSIntroRunner()
        ]
    }
}